import {
    Box,
    Grid,
    TextField,
    Typography,
} from '@mui/material';
import { useEffect } from 'react';
import { useTheme } from "@mui/material/styles";
import info from '../../assets/info-icon.svg';

export const ProgramTab = ({ sourceData, setSourceData, programOptions, sectorOptions}: any) => {
    const theme = useTheme();
    useEffect(() => {
        document.body.classList.remove("v2Background");
    },);
    
    const trimmedProgram = sourceData.program?.trim() || "";
    const isError = !trimmedProgram || trimmedProgram.length > 64;

    const getHelperText = () => {
        if (!trimmedProgram) {
            return 'Program name is required.';
        }
        if (trimmedProgram.length > 64) {
            return 'Program name cannot exceed 64 characters.';
        }
        return '';
    };

    return (
        <Box className={"main-bordered-container"} sx={{ mt: 3, padding: '20px', borderRadius: '8px' }}>
            <Typography variant="body2" sx={{ opacity: 0.7, mb: 4, px:2, color: 'textLight.main',display:'flex',gap:'4px'}}>
                <img src={info} alt="" /> This section is to configure program.
            </Typography>

            <Grid container spacing={2} mb={2} px={2}>
                
                <Grid item xs={9}>
                    <TextField
                        label="Program name*"
                        variant="outlined"
                        size="small"
                        value={sourceData.program}
                        error={isError}                     // <-- show red error border when true
                        helperText={getHelperText()}
                            onChange={(e) => {const value = e.target.value; setSourceData({ ...sourceData, program: value });}}
                        onBlur={(e) => {
                            const trimmed = e.target.value.trim();
                            setSourceData({ ...sourceData, program: trimmed });
                        }}
                        onKeyDown={(e) => {
                            const input = e.target as HTMLInputElement;
                            if (e.key === ' ' && input.selectionStart === 0 ) {
                                e.preventDefault(); // Block leading space
                            }
                        }}
                        // 1) Label forced to black (default, focused, and when shrunk)
                        InputLabelProps={{
                            sx: {
                            '&&': { color: `${theme.palette.textLight.main} !important` },
                            '&.Mui-focused': { color: 'textLight.main' },
                            '&.MuiInputLabel-shrink': { color: 'textLight.main' },
                            },
                        }}
                        sx={{
                            width: '100%',
                            // input text color
                            '& .MuiInputBase-input': { color: 'textLight.main' },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: 'textLight.main'
                                },
                                '&:hover fieldset': {
                                    borderColor: 'textLight.main'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'textLight.main'
                                }
                            },
                        }}
                    />

                </Grid>
            </Grid>
        </Box>
    )
}